import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../../../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/materials/data-sources/product-types')({
  staticData: toStaticData(CRT_ROUTES['/crt/materials/data-sources/product-types']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
